module.exports = __webpack_public_path__ + "static/media/14.52a981c3.png";